import {ref} from 'vue'
import { JWTService } from '@/shared/services/jwt';
import axiosInstance from "./axios-instance";

const valoresIniciais = [null, [], {}, '', undefined]

function get(url, valorInicial = 0,params){
    const res = ref(valoresIniciais[valorInicial])
    const erro = ref(null)


    const requisicao = axiosInstance.get(url, {
      headers: {
        'Authorization': `Bearer ${JWTService.GetToken()}`
      },
      params
  })
    .then((response) => {
      res.value = response.data.data || response.data
      return response
    })
    .catch((err) => {
      erro.value = err
      return err
    });

    return { res, erro, requisicao }
}

function getArray(url){
  return get(url, 1)
}

function getObj(url){
  return get(url, 2)
}

function postArray(url, data){
  return post(url, data, 1)
}

function post(url, data, valorIncial = 0){
  const res = ref(valoresIniciais[valorIncial])
  const erro = ref(null)

  const requisicao = axiosInstance.post(url, data, {
      headers: {
        'Authorization': `Bearer ${JWTService.GetToken()}`
      }
  })
    .then((response) => {
      res.value = response.data.data || response.data
      return response
    })
    .catch((err) => {
      erro.value = err
      return err
    })

  return { res, erro, requisicao }
}

const http = {
  get,
  getArray,
  post,
  getObj,
  postArray
}

export default http
